export default __webpack_public_path__ + "static/tag-dont-3-light-9ae0789979ea271ffd449b1005a6aac0469654137cbe76950beb572a0cb5559c.png";